import { useCallback, useState } from "react";

export type DesignTab = "colors" | "typography" | "components";

export function useDesignTabs(initial: DesignTab = "colors") {
  const [tab, setTab] = useState<DesignTab>(initial);
  const select = useCallback((t: DesignTab) => {
    setTab(t);
  }, []);
  return { tab, select };
}
